import React, {Component} from 'react';
import PropTypes from 'prop-types';

import styles from './Avatar.module.css';

import openPopup from '../../../public/js/util/imagePopup';
import {connect} from 'react-redux';

import FALLBACK_IMAGE from './avatar-placeholder.png';

class Avatar extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {imageExists: true};

        this.onImageUnavailable = () => {
            this.setState({imageExists: false});
        };
    }

    render() {
        const externalId = this.props.participant.externalId;

        const avatarUrl = 'https://sis.vsem.cz/sis/vysoka-skola/moje-fotka?id={{externalId}}'.replace('{{externalId}}', externalId);

        const elementStyles = {
            backgroundImage: `url(${this.state.imageExists ? avatarUrl : FALLBACK_IMAGE})`,
            cursor:          this.state.imageExists ? 'pointer' : 'default'
        };

        return (
            <div className={styles.avatar}
                 style={elementStyles}
                 onClick={() => openPopup(avatarUrl)}
            >
                <img src={avatarUrl} onError={this.onImageUnavailable}/>
            </div>
        );
    }
}

Avatar.propTypes = {
    participantId: PropTypes.number.isRequired,
};

export default connect(
    (state, props) => ({
        participant: state.getIn(['participants', props.participantId])
    })
)(Avatar);
